import React from "react";
import PropTypes from "prop-types";
import { loadCSS } from "fg-loadcss/src/loadCSS";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";

import {
    Card,
    CardHeader,
    CardMedia,
    CardContent,
    Avatar,
    Fade,
    Snackbar,
    SnackbarContent,
    Select,
    MenuItem,
    TextField,
    Button,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContentText,
    DialogContent,
    InputLabel,
    Icon,
    Typography,
    FormControl,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import { connect } from "react-redux";
import { AccountBox } from "@material-ui/icons";
import {
    getUsers,
    setSelectedUserUUID,
    setSelectedTab,
    postEditedUser,
    getQualifications,
    uploadImage,
    removeImage
} from "./actions";
import { selectUsernames, selectedUser, getProfileList, selectUploadedImage } from "./selectors";
import labels from "./labels.json";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import _ from "lodash";

const styles = theme => ({
    "*": {
        transition: ".3s ease-in-out"
    },
    avatar: {
        margin: 10,
        padding: 10,
        backgroundColor: "rgb(63,81,181)"
    },
    bigAvatar: {
        width: "50%",
        height: "auto",
        display: "block",
        margin: "0 auto",
        position: "relative"
    },

    actions: {
        display: "flex"
    },
    expand: {
        transform: "rotate(0deg)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        }),
        marginLeft: "auto"
    },
    icon: {
        width: "auto",
        color: "inherit"
    },
    card: {
        fontSize: 18,
        maxWidth: 345,
        overflow: "visible"
    },
    media: {
        height: 0,
        paddingTop: "56.25%" // 16:9
    },
    expandOpen: {
        transform: "rotate(180deg)"
    },

    button: {
        margin: 10
    },
    textField: {
        margin: 20,
        width: "75%"
    },
    form: {
        margin: 20,
        width: "75%"
    },
    picker: {
        fontSize: "12px"
    },
    paper: {
        padding: 12
    },
    tabTitle: {
        width: "100%",
        boxShadow: "none"
    },
    tabText: {
        color: "white"
    },
    bgGreen: {
        backgroundColor: "green"
    },
    bgAmber: {
        backgroundColor: "orange"
    },
    bgRed: {
        backgroundColor: "red"
    },
    activeTab: {
        backgroundColor: "rgb(63,81,181)",
        borderRadius: 8,
        color: "white",
        "&:hover": {
            backgroundColor: "rgb(63,81,211)"
        }
    },
    hr: { color: "#bbb", backgroundColor: "#bbb", border: "#bbb" },
    tab: {
        borderRadius: 8,
        color: "grey"
    },
    table: {
        border: "1px solid #cccccc",
        borderRadius: 4
    }
});

class ProfileEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fileSuccess: false,
            fileUploading: false,
            fileProgress: false,
            selectedUUID: 0,
            selectedProfile: false,
            profile: [],
            oldProfile: [],
            alertOpen: false,
            uuid: [],
            tabIndex: 0,
            spacing: 16,
            qualID: 0
        };
        props.getUsers();
        props.getQualifications();
    }
    componentDidMount() {
        loadCSS(
            "https://use.fontawesome.com/releases/v5.1.0/css/all.css",
            document.querySelector("#insertion-point-jss")
        );
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.selectedUUID !== prevState.selectedUUID) {
            this.setState({
                profile: this.props.selectedUser.user.profile,
                oldProfile: _.cloneDeep(this.props.selectedUser.user.profile),
                selectedProfile: true,
                uuid: this.props.selectedUser.uuid
            });
        }
    }

    handleClickOpen = event => {
        event.preventDefault();
        this.setState({ alertOpen: true });
    };

    handleClose = () => {
        this.setState({
            alertOpen: false
        });
    };
    isActiveTab = id => {
        const { tabIndex } = this.state;
        return tabIndex === id;
    };
    onFormSubmit = () => {
        this.props.postEditedUser(this.state.profile, this.state.uuid);
        this.handleClose();
    };

    renderTextDetail(key) {
        const { profile } = this.state;
        const { classes } = this.props;
        if (typeof profile[key] === "undefined") {
            profile[key] = "";
            this.setState({ profile });
        }

        let label = "";
        if (typeof labels[key] !== "undefined") label = labels[key];
        else label = key.replace(/_/g, " ");

        return (
            <TextField
                key={key}
                value={profile[key]}
                label={label}
                className={classes.textField}
                onChange={val => {
                    profile[key] = val.target.value;
                    this.setState({ profile });
                }}
            />
        );
    }
    handleUploadStart = e => {
        this.setState({ isUploading: true });
    };
    handleProgress = progress => this.setState({ progress });
    handleUploadError = error => console.error(error);
    handleFileRemove(filename, i) {
        const { profile } = this.state;
        this.props.removeFile(this.state.profile.job_name, filename, this.props.uploadedFiles, i);
        let files = profile["attached_files"];
        const index = files.indexOf(i);
        files.splice(index, 1);
        profile["attached_files"] = files;

        this.setState({ profile });
    }
    handleFileUploader = event => {
        let i = this.state.qualID;
        const { profile } = this.state;

        this.props.uploadImage(
            this.state.profile["uid"],
            event.target.files[0],
            profile,
            this.state.qualID,
            status => {
                if (status.inProgress) {
                    this.setState({ fileProgress: status.progress });
                } else if (status.finished) {
                    this.setState({ fileSuccess: true, fileProgress: false });
                    if (profile["qualifications"][i]["image_url"] && this.props.uploadedImg)
                        profile["qualifications"][i]["image_url"] = this.props.uploadedImg;
                    this.setState({ profile });
                } else if (status.error) {
                }
            }
        );
    };
    handleUploadSuccess = filename => {
        let i = this.state.qualID;
        const { profile } = this.state;

        this.props.uploadImage(this.state.profile["uid"], filename, profile, this.state.qualID);

        this.setState({ isUploading: false });
        if (profile["qualifications"][i]["image_url"] && this.props.uploadedImg)
            profile["qualifications"][i]["image_url"] = this.props.uploadedImg;
        this.setState({ profile });
    };
    renderImgDetail(i) {
        const { profile } = this.state;
        const { classes } = this.props;
        let key = "qualifications";
        let img = "./defaultImg.png";

        if (
            profile[key][i].image_url !== "default" &&
            profile[key][i].image_url !== "" &&
            profile[key][i].image_required
        )
            img = profile[key][i].image_url;

        return (
            <Grid key={i} item classes={classes.profileTabinnerItem} xs={6} md={4} lg={4}>
                <Card className={classes.card}>
                    <CardMedia className={classes.media} image={img} title="" />
                    <CardContent>
                        <div>
                            <FormControl className={classes.form} key={i}>
                                {this.state.fileProgress !== false && (
                                    <p
                                        style={{
                                            width: "100%",
                                            background: "orange",
                                            padding: "1em",
                                            color: "white",
                                            fontWeight: "600",
                                            borderRadius: 4
                                        }}
                                    >
                                        File Upload Progress: {this.state.fileProgress}%
                                    </p>
                                )}

                                <input
                                    accept="image/*"
                                    type="file"
                                    onChange={this.handleFileUploader}
                                    style={{ display: "none" }}
                                    ref={fileInput => (this.fileInput = fileInput)}
                                />
                                <Typography>{this.state.uploadFileName}</Typography>
                                <Button
                                    key={i}
                                    color="primary"
                                    style={{
                                        width: "auto",
                                        display: "inline"
                                    }}
                                    onClick={() => {
                                        this.setState({ qualID: i });
                                        this.fileInput.click();
                                    }}
                                    variant="contained"
                                    className={classes.button}
                                >
                                    Select File(s)
                                </Button>
                            </FormControl>
                        </div>

                        {profile[key][i].expiry_required && (
                            <div className={classes.form}>
                                <InputLabel className={classes.picker}>
                                    {profile[key][i].title} Expiry Date
                                </InputLabel>
                                <p />
                                <DayPickerInput
                                    key={key + "expiry"}
                                    placeholder="Enter Expiry Date"
                                    value={profile[key][i].expiry_date}
                                    onDayChange={val => {
                                        profile[key][i].expiry_date = val.toLocaleDateString();
                                        this.setState({ profile });
                                    }}
                                />
                            </div>
                        )}

                        {profile[key][i].verified_required && (
                            <div className={classes.form}>
                                <InputLabel>Qualification Verified</InputLabel>
                                <Select
                                    key={key + "verified"}
                                    value={profile["qualifications"][i].verified}
                                    onChange={val => {
                                        profile[key][i].verified = val.target.value;
                                        this.setState({ profile });
                                    }}
                                >
                                    <MenuItem value="Yes">Yes</MenuItem>
                                    <MenuItem value="No">No</MenuItem>
                                </Select>
                            </div>
                        )}

                        {profile[key][i].number_required && (
                            <TextField
                                key={key + "number"}
                                value={profile[key][i].number}
                                label={"Reg. No."}
                                className={classes.textField}
                                onChange={val => {
                                    profile[key][i].number = val.target.value;
                                    this.setState({ profile });
                                }}
                            />
                        )}
                    </CardContent>
                </Card>
            </Grid>
        );
    }

    renderYesNoDetail(key) {
        const { profile } = this.state;
        const { classes } = this.props;
        if (typeof profile[key] === "undefined") {
            profile[key] = "No";
            this.setState({ profile });
        }

        let label = "";
        if (typeof labels[key] !== "undefined") label = labels[key];
        else label = key.replace(/_/g, " ");

        return (
            <FormControl className={classes.form}>
                <InputLabel>{label}</InputLabel>
                <Select
                    key={key}
                    value={profile[key]}
                    onChange={val => {
                        profile[key] = val.target.value;
                        this.setState({ profile });
                    }}
                >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                </Select>
            </FormControl>
        );
    }
    renderExpiryDetail(key) {
        const { profile } = this.state;
        const { classes } = this.props;
        if (typeof profile[key] === "undefined") {
            profile[key] = "";
            this.setState({ profile });
        }

        let label = "";
        if (typeof labels[key] !== "undefined") label = labels[key];
        else label = key.replace(/_/g, " ");

        return (
            <div key={key} className={classes.form}>
                <InputLabel className={classes.picker}>{label}</InputLabel>
                <p />
                <DayPickerInput
                    key={key}
                    value={profile[key]}
                    onDayChange={val => {
                        profile[key] = val.toLocaleDateString();
                        this.setState({ profile });
                    }}
                />
            </div>
        );
    }
    isVerified(verified) {
        if (verified === "Yes" || verified === "yes") return true;
        else return false;
    }

    monthDiff(date) {
        const { classes } = this.props;
        if (typeof date === "undefined") return classes.bgRed;
        date = date.split("/");
        let a = moment();

        let b = moment(date[0] + date[1] + date[2], "DDMMYYYY");

        let months = b.diff(a, "days");
        if (months < 1) return classes.bgRed;
        else if (months < 90) return classes.bgAmber;
        else return classes.bgGreen;
    }

    tableRowDetail(title, verified, date) {
        const { classes } = this.props;

        return (
            <TableRow className={classes.row} key={title}>
                <TableCell component="th" scope="row">
                    {title}
                </TableCell>
                <TableCell className={this.isVerified(verified) ? classes.bgGreen : classes.bgRed}>
                    {verified}
                </TableCell>
                <TableCell className={this.monthDiff(date)}>{date}</TableCell>
            </TableRow>
        );
    }
    render() {
        const { classes } = this.props;
        const { profile } = this.state;
        const { tabIndex } = this.state;
        return (
            <div>
                <Grid container spacing={24}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Card>
                            <CardHeader
                                avatar={
                                    <Avatar aria-label="Profile-Edit" className={classes.avatar}>
                                        <AccountBox />
                                    </Avatar>
                                }
                                title={<Typography variant="headline">Profile Edit</Typography>}
                            />
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={4} lg={3}>
                        <Paper className={classes.paper}>
                            <Grid container>
                                <Grid item xs={12} md={12} lg={12}>
                                    <Select
                                        value={this.state.selectedUUID}
                                        onChange={event => {
                                            this.props.setSelectedUserUUID(event.target.value);
                                            this.setState({
                                                selectedUUID: event.target.value
                                            });
                                        }}
                                    >
                                        {!this.state.selectedProfile && (
                                            <MenuItem value={this.state.selectedUUID}>
                                                Please Choose a User
                                            </MenuItem>
                                        )}

                                        {this.props.usernames.map((e, i) => {
                                            return (
                                                <MenuItem key={i} value={e.uid}>
                                                    {e.name}
                                                </MenuItem>
                                            );
                                        })}
                                    </Select>
                                </Grid>
                                <Grid item xs={12} md={12} lg={12}>
                                    <List component="nav">
                                        <ListItem
                                            button
                                            className={
                                                this.isActiveTab(0)
                                                    ? classes.activeTab
                                                    : classes.tab
                                            }
                                            onClick={val => {
                                                this.setState({ tabIndex: 0 });
                                            }}
                                        >
                                            <ListItemIcon>
                                                <Icon
                                                    className={classNames(
                                                        classes.icon,
                                                        "fas fa-user fa-2x"
                                                    )}
                                                />
                                            </ListItemIcon>
                                            <ListItemText>
                                                <p
                                                    className={
                                                        this.isActiveTab(0) ? classes.tabText : null
                                                    }
                                                >
                                                    General Overview
                                                </p>
                                            </ListItemText>
                                        </ListItem>
                                        <ListItem
                                            button
                                            className={
                                                this.isActiveTab(1)
                                                    ? classes.activeTab
                                                    : classes.tab
                                            }
                                            onClick={val => {
                                                this.setState({ tabIndex: 1 });
                                            }}
                                        >
                                            <ListItemIcon>
                                                <Icon
                                                    className={classNames(
                                                        classes.icon,
                                                        "fas fa-user fa-2x"
                                                    )}
                                                />
                                            </ListItemIcon>
                                            <ListItemText>
                                                <p
                                                    className={
                                                        this.isActiveTab(1) ? classes.tabText : null
                                                    }
                                                >
                                                    Personal Info
                                                </p>
                                            </ListItemText>
                                        </ListItem>
                                        <ListItem
                                            button
                                            className={
                                                this.isActiveTab(2)
                                                    ? classes.activeTab
                                                    : classes.tab
                                            }
                                            onClick={val => {
                                                this.setState({ tabIndex: 2 });
                                            }}
                                        >
                                            <ListItemIcon>
                                                <Icon
                                                    className={classNames(
                                                        classes.icon,
                                                        "fas fa-certificate fa-2x"
                                                    )}
                                                />
                                            </ListItemIcon>
                                            <ListItemText>
                                                <p
                                                    className={
                                                        this.isActiveTab(2) ? classes.tabText : null
                                                    }
                                                >
                                                    Training
                                                </p>
                                            </ListItemText>
                                        </ListItem>
                                        {/*  */}
                                        <ListItem
                                            button
                                            className={
                                                this.isActiveTab(3)
                                                    ? classes.activeTab
                                                    : classes.tab
                                            }
                                            onClick={val => {
                                                this.setState({ tabIndex: 3 });
                                            }}
                                        >
                                            <ListItemIcon>
                                                <Icon
                                                    className={classNames(
                                                        classes.icon,
                                                        "fas fa-user-secret fa-2x"
                                                    )}
                                                />
                                            </ListItemIcon>
                                            <ListItemText>
                                                <p
                                                    className={
                                                        this.isActiveTab(3) ? classes.tabText : null
                                                    }
                                                >
                                                    Security
                                                </p>
                                            </ListItemText>
                                        </ListItem>
                                    </List>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={8} lg={9}>
                        <Paper className={classes.paper}>
                            {this.state.selectedProfile && (
                                <form onSubmit={this.handleClickOpen}>
                                    <Grid container>
                                        {tabIndex === 0 && (
                                            <Fade
                                                in={true}
                                                timeout={{
                                                    enter: 400,
                                                    exit: 400
                                                }}
                                            >
                                                <Grid
                                                    item
                                                    classes={classes.profileTabItem}
                                                    xs={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Card className={classes.tabTitle}>
                                                        <CardHeader
                                                            avatar={
                                                                <Avatar
                                                                    aria-label="Profile-Edit"
                                                                    className={classes.avatar}
                                                                >
                                                                    <Icon
                                                                        className={classNames(
                                                                            classes.icon,
                                                                            "fas fa-user fa-1x"
                                                                        )}
                                                                    />
                                                                </Avatar>
                                                            }
                                                            title={
                                                                <Typography variant="headline">
                                                                    General Information
                                                                </Typography>
                                                            }
                                                        />
                                                    </Card>
                                                    <Grid container spacing={8}>
                                                        <Grid
                                                            item
                                                            classes={classes.profileTabinnerItem}
                                                            xs={12}
                                                            md={6}
                                                            lg={6}
                                                        >
                                                            <Avatar
                                                                alt="profile avatar"
                                                                src={profile["profile_image_url"]}
                                                                className={classNames(
                                                                    classes.bigAvatar
                                                                )}
                                                            />
                                                            <br />
                                                            <Typography
                                                                variant="subheading"
                                                                align="center"
                                                            >
                                                                Full Name:
                                                            </Typography>
                                                            <Typography
                                                                variant="body1"
                                                                align="center"
                                                            >
                                                                {profile["first_name"]}{" "}
                                                                {profile["last_name"]}
                                                            </Typography>
                                                            <hr className={classes.hr} />
                                                            <Typography
                                                                variant="subheading"
                                                                align="center"
                                                            >
                                                                Email:
                                                            </Typography>
                                                            <Typography
                                                                variant="body1"
                                                                align="center"
                                                            >
                                                                {profile["email"]}
                                                            </Typography>
                                                            <hr className={classes.hr} />
                                                            <Typography
                                                                variant="subheading"
                                                                align="center"
                                                            >
                                                                Job Title:
                                                            </Typography>
                                                            <Typography
                                                                variant="body1"
                                                                align="center"
                                                            >
                                                                {profile["job_title"]}
                                                            </Typography>
                                                            <hr className={classes.hr} />
                                                            <Typography
                                                                variant="subheading"
                                                                align="center"
                                                            >
                                                                Account Created:
                                                            </Typography>
                                                            <Typography
                                                                variant="body1"
                                                                align="center"
                                                            >
                                                                {profile["account_created"]}
                                                            </Typography>
                                                            <hr className={classes.hr} />
                                                            <Typography
                                                                variant="subheading"
                                                                align="center"
                                                            >
                                                                Last Active:
                                                            </Typography>
                                                            <Typography
                                                                variant="body1"
                                                                align="center"
                                                            >
                                                                {profile["last_active"]}
                                                            </Typography>
                                                            <hr className={classes.hr} />
                                                            <Typography
                                                                variant="subheading"
                                                                align="center"
                                                            >
                                                                EULA Agreed:
                                                            </Typography>
                                                            <Typography
                                                                variant="body1"
                                                                align="center"
                                                            >
                                                                {profile["agreed_to_eula"]}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            classes={classes.profileTabinnerItem}
                                                            xs={12}
                                                            md={6}
                                                            lg={6}
                                                        >
                                                            {profile["qualifications"] && (
                                                                <Table className={classes.table}>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell>
                                                                                Training
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                Verified
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                Expiry Date
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {Object.keys(
                                                                            profile[
                                                                                "qualifications"
                                                                            ]
                                                                        ).map((e, i) => {
                                                                            return this.tableRowDetail(
                                                                                profile[
                                                                                    "qualifications"
                                                                                ][e].title,
                                                                                profile[
                                                                                    "qualifications"
                                                                                ][e].verified,
                                                                                profile[
                                                                                    "qualifications"
                                                                                ][e].expiry_date
                                                                            );
                                                                        })}
                                                                    </TableBody>
                                                                </Table>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Fade>
                                        )}
                                        {tabIndex === 1 && (
                                            <Fade
                                                in={true}
                                                timeout={{
                                                    enter: 400,
                                                    exit: 400
                                                }}
                                            >
                                                <Grid
                                                    item
                                                    classes={classes.profileTabItem}
                                                    xs={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Card className={classes.tabTitle}>
                                                        <CardHeader
                                                            avatar={
                                                                <Avatar
                                                                    aria-label="Profile-Edit"
                                                                    className={classes.avatar}
                                                                >
                                                                    <Icon
                                                                        className={classNames(
                                                                            classes.icon,
                                                                            "fas fa-user fa-1x"
                                                                        )}
                                                                    />
                                                                </Avatar>
                                                            }
                                                            title={
                                                                <Typography variant="headline">
                                                                    Personal Information
                                                                </Typography>
                                                            }
                                                        />
                                                    </Card>
                                                    <Grid container>
                                                        <Grid
                                                            item
                                                            classes={classes.profileTabinnerItem}
                                                            xs={12}
                                                            md={6}
                                                            lg={6}
                                                        >
                                                            <Avatar
                                                                alt="profile avatar"
                                                                src={profile["profile_image_url"]}
                                                                className={classNames(
                                                                    classes.bigAvatar
                                                                )}
                                                            />

                                                            {this.renderTextDetail("first_name")}
                                                            {this.renderTextDetail("last_name")}
                                                            {this.renderTextDetail("email")}
                                                            {this.renderTextDetail(
                                                                "level_of_experience_in_similar_industry"
                                                            )}
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            classes={classes.profileTabinnerItem}
                                                            xs={12}
                                                            md={6}
                                                            lg={6}
                                                        >
                                                            {this.renderTextDetail("job_title")}

                                                            {this.renderTextDetail("last_active")}
                                                            {this.renderTextDetail(
                                                                "account_created"
                                                            )}

                                                            {this.renderYesNoDetail(
                                                                "agreed_to_eula"
                                                            )}

                                                            {this.renderTextDetail(
                                                                "agreed_to_eula_timestamp"
                                                            )}

                                                            {this.renderTextDetail(
                                                                "years_in_present_position"
                                                            )}

                                                            <FormControl className={classes.form}>
                                                                <InputLabel>
                                                                    {
                                                                        labels[
                                                                            "direct_or_subcontractor"
                                                                        ]
                                                                    }
                                                                </InputLabel>
                                                                <Select
                                                                    key="direct_or_subcontractor"
                                                                    value={
                                                                        profile[
                                                                            "direct_or_subcontractor"
                                                                        ]
                                                                    }
                                                                    onChange={val => {
                                                                        profile[
                                                                            "direct_or_subcontractor"
                                                                        ] = val.target.value;
                                                                        this.setState({
                                                                            profile
                                                                        });
                                                                    }}
                                                                >
                                                                    <MenuItem value="Direct">
                                                                        Direct
                                                                    </MenuItem>
                                                                    <MenuItem value="Subcontract">
                                                                        Subcontract
                                                                    </MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Fade>
                                        )}
                                        {tabIndex === 2 && (
                                            <Fade
                                                in={true}
                                                timeout={{
                                                    enter: 400,
                                                    exit: 400
                                                }}
                                            >
                                                <Grid
                                                    item
                                                    classes={classes.profileTabItem}
                                                    xs={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Card className={classes.tabTitle}>
                                                        <CardHeader
                                                            avatar={
                                                                <Avatar
                                                                    aria-label="Profile-Edit"
                                                                    className={classes.avatar}
                                                                >
                                                                    <Icon
                                                                        className={classNames(
                                                                            classes.icon,
                                                                            "fas fa-certificate fa-2x"
                                                                        )}
                                                                    />
                                                                </Avatar>
                                                            }
                                                            title={
                                                                <Typography variant="headline">
                                                                    Training
                                                                </Typography>
                                                            }
                                                        />
                                                    </Card>

                                                    <Grid container spacing={16}>
                                                        {typeof profile["qualifications"] !==
                                                            "undefined" &&
                                                            Object.keys(
                                                                profile["qualifications"]
                                                            ).map((e, i) => {
                                                                return this.renderImgDetail(e);
                                                            })}
                                                    </Grid>
                                                </Grid>
                                            </Fade>
                                        )}
                                        {tabIndex === 3 && (
                                            <Fade
                                                in={true}
                                                timeout={{
                                                    enter: 400,
                                                    exit: 400
                                                }}
                                            >
                                                <Grid
                                                    item
                                                    classes={classes.profileTabItem}
                                                    xs={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Card className={classes.tabTitle}>
                                                        <CardHeader
                                                            avatar={
                                                                <Avatar
                                                                    aria-label="Profile-Edit"
                                                                    className={classes.avatar}
                                                                >
                                                                    <Icon
                                                                        className={classNames(
                                                                            classes.icon,
                                                                            "fas fa-user-secret fa-2x"
                                                                        )}
                                                                    />
                                                                </Avatar>
                                                            }
                                                            title={
                                                                <Typography variant="headline">
                                                                    Security
                                                                </Typography>
                                                            }
                                                        />
                                                    </Card>
                                                    <Grid container spacing={16}>
                                                        <FormControl className={classes.form}>
                                                            <InputLabel>
                                                                {labels.access_level}
                                                            </InputLabel>
                                                            <Select
                                                                value={profile.access_level}
                                                                onChange={val => {
                                                                    profile.access_level =
                                                                        val.target.value;
                                                                    this.setState({
                                                                        profile
                                                                    });
                                                                }}
                                                            >
                                                                <MenuItem value={"Level 0"}>
                                                                    Level 0
                                                                </MenuItem>
                                                                <MenuItem value={"Level 1"}>
                                                                    Level 1
                                                                </MenuItem>
                                                                <MenuItem value={"Level 2"}>
                                                                    Level 2
                                                                </MenuItem>
                                                                <MenuItem value={"Level 3"}>
                                                                    Level 3
                                                                </MenuItem>
                                                                <MenuItem value={"Level 4"}>
                                                                    Level 4
                                                                </MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                        <FormControl className={classes.form}>
                                                            <InputLabel>
                                                                {labels.security_level}
                                                            </InputLabel>
                                                            <Select
                                                                key="security_level"
                                                                value={profile["security_level"]}
                                                                onChange={val => {
                                                                    profile["security_level"] =
                                                                        val.target.value;
                                                                    this.setState({
                                                                        profile
                                                                    });
                                                                }}
                                                            >
                                                                <MenuItem value="User">
                                                                    User
                                                                </MenuItem>
                                                                <MenuItem value="Admin">
                                                                    Admin
                                                                </MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                            </Fade>
                                        )}
                                    </Grid>

                                    <Button
                                        variant="contained"
                                        type="reset"
                                        size="large"
                                        className={classes.button}
                                        onClick={() => {
                                            this.setState({
                                                profile: this.state.oldProfile
                                            });
                                        }}
                                    >
                                        Reset
                                    </Button>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        size="large"
                                        className={classes.button}
                                    >
                                        Submit
                                    </Button>
                                    <Dialog
                                        open={this.state.alertOpen}
                                        onClose={this.handleClose}
                                        aria-labelledby="alert-dialog-title"
                                        aria-describedby="alert-dialog-description"
                                    >
                                        <DialogTitle id="alert-dialog-title">
                                            {"Please Ensure Details Are Correct"}
                                        </DialogTitle>
                                        <DialogContent>
                                            <DialogContentText id="alert-dialog-description">
                                                Please ensure details are correct before pressing
                                                submit
                                            </DialogContentText>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={this.handleClose} color="primary">
                                                Cancel
                                            </Button>
                                            <Button
                                                onClick={this.onFormSubmit}
                                                color="primary"
                                                autoFocus
                                            >
                                                Submit
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </form>
                            )}
                        </Paper>
                    </Grid>
                </Grid>
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left"
                    }}
                    autoHideDuration={6000}
                    open={this.state.fileSuccess}
                    onClose={() => {
                        this.setState({ fileSuccess: false });
                    }}
                >
                    <SnackbarContent
                        style={{ backgroundColor: "green", color: "white" }}
                        message="Image has been successfully uploaded!"
                    />
                </Snackbar>
            </div>
        );
    }
}

ProfileEdit.propTypes = {
    classes: PropTypes.object.isRequired
};

export default connect(
    store => {
        return {
            usernames: selectUsernames(store),
            selectedUser: selectedUser(store),
            Qualifications: getProfileList(store),
            uploadedImg: selectUploadedImage(store)
        };
    },
    {
        getQualifications,
        getUsers,
        setSelectedTab,
        setSelectedUserUUID,
        postEditedUser,
        uploadImage,
        removeImage
    }
)(withStyles(styles)(ProfileEdit));
